module.exports = __webpack_public_path__ + "static/media/linkedin-full.831a9224.svg";